import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const updateNewProductKey = 'updateNewProduct';

export interface UpdateNewProductState {
  updateNewProductResponse: any;
  updateNewProductFailure: any;
  loaded: boolean;
}

export const initialState: UpdateNewProductState = {
  updateNewProductResponse: undefined,
  updateNewProductFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,

  on(actions.updateNewProductSuccess, (state, action) => ({
    ...state,
    updateNewProductResponse: action.response,
    loaded: true
  })),

  on(actions.updateNewProductFailure, (state, action) => ({
    ...state,
    updateNewProductFailure: action.error
  }))
);

export const updateNewProduct = (state: UpdateNewProductState) => state.updateNewProductResponse;
